import { Col, Form, Modal, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useAuthContext } from "../../../../contexts/AuthContext";
import logger from "../../../../server/server";
import { createField } from "../../../../utils/hooks/FieldsFactory";
import Spinner from "../../Atomics/Spinner";

const NotVisibleField = styled.div`
    display: none;
`;

export const EditPopupConfigurations = ({ openModal, closeModal, isToEdit, selectedRecord, onOkModal, customWidth,
    customFooter, loading, modalTitle, customHeader, ...props }) => {
    // Obtém a função de tradução do hook useTranslation para uso na tradução de textos
    const { t } = useTranslation();
    const { user, tenant } = useAuthContext();
    const [selectedItem, setSelectedItem] = useState(null);
    const [fieldStatus, setFieldStatus] = useState({ validateStatus: '', help: '' });

    const [form] = Form.useForm();

    const areEqual = (obj1, obj2) => {
        if (obj1 && !obj2)
            return false;
        if (!obj1 && obj2)
            return false;

        if (obj1 === obj2) return true;

        if (Object.keys(obj1).length !== Object.keys(obj2).length) {
            console.log("Objects have a different number of keys.");
            return false;
        }

        for (let key in obj1) {
            if (obj1[key].key !== obj2[key].key || obj1[key].value !== obj2[key].value) {
                return false;
            }
        }

        return true;
    };

    const handleOk = () => {
        form
            .validateFields() // Validate and get form values
            .then((values) => {
                onOkModal(values); // Close the modal after submission
            })
            .catch((info) => {
                console.log('Validation Failed:', info);
            });
    };

    // Efeito para resetar o formulário quando selectedRecord mudar
    useEffect(() => {
        if (selectedRecord && !areEqual(selectedRecord, selectedItem) && isToEdit) {
            const defaultValues = selectedRecord?.reduce((acc, v) => {
                if (!v?.parent) {
                    acc[v.key] = v.value;
                } else {
                    acc[v.parent.key] = v.parent.value;
                    v.childs.forEach(child => {
                        acc[child.key] = child.value;
                    });
                }
                return acc;
            }, {});
            setSelectedItem(selectedRecord)
            form.setFieldsValue(defaultValues); // Reseta o formulário com os novos valores
        }
        logger.info("User " + user + " changed selectedRecord successuful! Tenant: " + tenant);
    }, [selectedRecord, form]);

    return (
        <form>
            <Modal
                title={modalTitle || t(isToEdit ? "Edit" : "Add")}
                open={openModal}
                onCancel={() => { closeModal(); }}
                onOk={() => {
                    handleOk()
                }}
                afterClose={() => {
                    form.resetFields();
                    setSelectedItem(null);
                }}
                width={customWidth || undefined}
                cancelButtonProps={{ loading: loading }}
                okButtonProps={{
                    disabled: props?.okButtonDisabled,
                    loading: loading
                }}
                footer={customFooter ? customFooter(form) : undefined}
            >
                {!selectedRecord &&
                    <div style={{ width: "100%", display: "flex", justifyContent: "center", height: "50vh", alignItems: "center" }}>
                        <Spinner stroke="green" />
                    </div>}
                {selectedRecord &&
                    <Form form={form}
                        layout="inline">
                        {customHeader && customHeader(form)}
                        <Row gutter={[16, 16]} style={{ width: "100%" }}>
                            {selectedRecord?.map((entry, index) => {

                                const isVisible = entry?.isVisible !== false;
                                if (!isVisible) {
                                    return (
                                        <NotVisibleField key={index}>
                                            {createField(form, entry, t, fieldStatus, setFieldStatus, props)}
                                        </NotVisibleField>
                                    )
                                }

                                return (
                                    <Col span={entry.size ?? 24} key={index} style={entry.style}>
                                        {createField(form, entry, t, fieldStatus, setFieldStatus, props)}
                                    </Col>
                                )
                            })}
                        </Row>
                    </Form>
                }
            </Modal>
        </form >
    )
}